export default __webpack_public_path__ + "static/media/web.2fe2d750.png";